"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.ChevronUp = exports.ChevronRight = exports.ChevronLeft = exports.ChevronDown = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors; // eslint-disable-next-line react/prop-types

var ChevronRightSvg = function ChevronRightSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    viewBox: "0 0 320 512",
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: colors.legacy[color] || color,
    d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
  }));
};

var ChevronRight = (0, _styledComponents.default)(ChevronRightSvg).withConfig({
  displayName: "ChevronRight",
  componentId: "sc-b70ku5-0"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
exports.ChevronRight = ChevronRight;
ChevronRight.defaultProps = {
  color: "" + colors.brand.snswSecondaryBlue,
  height: 15,
  width: 15
};
var ChevronLeft = (0, _styledComponents.default)(ChevronRight).withConfig({
  displayName: "ChevronLeft",
  componentId: "sc-b70ku5-1"
})(["transform:rotate(180deg);"]);
exports.ChevronLeft = ChevronLeft;
var ChevronDown = (0, _styledComponents.default)(ChevronRight).withConfig({
  displayName: "ChevronDown",
  componentId: "sc-b70ku5-2"
})(["transform:rotate(90deg);"]);
exports.ChevronDown = ChevronDown;
var ChevronUp = (0, _styledComponents.default)(ChevronRight).withConfig({
  displayName: "ChevronUp",
  componentId: "sc-b70ku5-3"
})(["transform:rotate(-90deg);"]);
exports.ChevronUp = ChevronUp;